import {
  UPDATE_TASK_TEMPLATE_USER_TASK_PAGE_NUMBER,
  GET_TASK_TEMPLATE_USER_TASK_PENDING,
  GET_TASK_TEMPLATE_USER_TASK,
  DELETE_TASK_TEMPLATE_USER_TASK,
  FETCH_TASK_TEMPLATE_USER_TASK,
  EDIT_TASK_TEMPLATE_USER_TASK,
  ADD_TASK_TEMPLATE_USER_TASK,
  CLEAR_TASK_TEMPLATE_USER_TASK,
  RESET_TASK_TEMPLATE_USER_TASK,
  CLEAR_ALL,
} from "constants/actions";

const initialState = {
  task_template_user_task: [],
  updated: false,
  pageNumber: 1,
  pending: false,
};

export default function TaskTemplateUserTask(state = initialState, action) {
  switch (action.type) {
    case UPDATE_TASK_TEMPLATE_USER_TASK_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload,
        pending: false,
        updated: false,
      };
    case GET_TASK_TEMPLATE_USER_TASK_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_TASK_TEMPLATE_USER_TASK:
      return {
        ...state,
        task_template_user_task: action.payload,
        pending: false,
      };
    case FETCH_TASK_TEMPLATE_USER_TASK:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case EDIT_TASK_TEMPLATE_USER_TASK:
      return {
        ...state,
        updated: action.payload,
        pending: false,
      };
    case DELETE_TASK_TEMPLATE_USER_TASK:
      return {
        ...state,
        updated: action.payload,
        pending: false,
      };
    case ADD_TASK_TEMPLATE_USER_TASK:
      return {
        ...state,
        updated: action.payload,
        pending: false,
      };
    case RESET_TASK_TEMPLATE_USER_TASK:
      return {
        ...state,
        updated: false,
      };
    case CLEAR_TASK_TEMPLATE_USER_TASK:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}
